import { cn } from '@heidi/utils';

export const popoverMenuItemBaseStyles = cn(
  'flex w-full cursor-pointer items-start gap-2 rounded-md p-2 text-start',
  'hover:bg-surface-hover'
);

export const popoverMenuItemIconStyles =
  'mt-0.5 flex shrink-0 items-center justify-center';

export const popoverMenuItemContentStyles = 'flex min-w-0 flex-1 flex-col gap-0.5';

export const popoverMenuItemTitleBaseStyles =
  'truncate text-sm font-normal text-text-primary';

export const popoverMenuItemTitleSelectedStyles = 'font-medium text-text-primary';

export const popoverMenuItemIconSelectedStyles = 'text-text-primary';

export const popoverMenuItemDescriptionStyles = 'truncate text-xs text-text-secondary';

export const popoverMenuItemAccessoryStyles = 'mt-0.5 flex shrink-0 items-center';

export const popoverMenuItemDisabledStyles =
  'cursor-default opacity-50 hover:bg-transparent';
